import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import { status_aktif, jenis_berita } from "../../constants/general";

import { FOTO_CONTENT_HOST } from "../../constants/siteConfig";

import Cropper from "react-crop";
import "react-crop/cropper.css";

import "babel-core/register";
import "babel-polyfill";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			cat_id: "",
			content_id: "",
			content_name: "",
			content_type: "content",
			content_image: "",
			content_shortdesc: "",
			content_file_type: "gambar",
			content_file_thumb: "",
			content_file_url: "",
			content_desc: "",
			content_status: "",
			content_tags: "",
			isButtonLoading: false,
			isLoading: false,
			image: null,
			previewImg: null,
			defaultImg: "./noimage.gif",
			editorState: EditorState.createEmpty(),
			dataCat: []
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	onChange(evt) {
		this.setState({
			previewImg: null,
			defaultImg: null,
			image: evt.target.files[0],
			content_image: ""
		});
	}

	async crop() {
		let image = await this.refs.crop.cropImage();
		this.setState({
			previewImg: window.URL.createObjectURL(image),
			defaultImg: null,
			content_image: window.URL.createObjectURL(image)
		});
	}

	clear() {
		this.refs.file.value = null;
		this.setState({
			previewImg: null,
			defaultImg: "./noimage.gif",
			image: null,
			content_image: ""
		});
	}

	imageLoaded(img) {
		if (
			img.naturalWidth &&
			img.naturalWidth < 262 &&
			img.naturalHeight &&
			img.naturalHeight < 147
		) {
			this.crop();
		}
	}

	onEditorStateChange(editorState) {
		this.setState({
			content_desc: draftToHtml(convertToRaw(editorState.getCurrentContent())),
			editorState: editorState
		});
	}

	handleSubmit() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("cat_id", this.state.cat_id);
		formData.append("content_id", this.state.content_id);
		formData.append("content_type", this.state.content_type);
		formData.append("content_name", this.state.content_name);
		formData.append("content_image", this.state.image);
		formData.append("content_file_type", this.state.content_file_type);
		formData.append("content_file_url", this.state.content_file_url);
		formData.append("content_shortdesc", this.state.content_shortdesc);
		formData.append("content_desc", this.state.content_desc);
		formData.append("content_tags", '');
		formData.append("content_status", this.state.content_status);

		const url = this.props.mode === "Tambah" ? "konten/add" : "konten/edit";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/news");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}

	loadData() {
		axios({
			method: "post",
			url: "/kategori"
		}).then(response => {
			const results = response.data;
			const dCat = [];

			results.data.forEach(function(e) {
				dCat.push({ key: e.cat_id, value: e.cat_name });
			});

			this.setState({
				dataCat: dCat
			});
		});

		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			axios({
				method: "get",
				url: "/konten/" + this.props.match.params.content_id
			})
				.then(response => {
					const result = response.data;

					if (result.success) {
						const contentBlock = htmlToDraft(result.data.content_desc);

						if (contentBlock) {
							const contentState = ContentState.createFromBlockArray(
								contentBlock.contentBlocks
							);
							const editorState = EditorState.createWithContent(contentState);

							this.setState({
								editorState: editorState
							});
						}

						this.setState({
							cat_id: result.data.cat_id,
							content_id: result.data.content_id,
							content_name: result.data.content_name,
							content_image: result.data.content_image,
							content_shortdesc: result.data.content_shortdesc,
							content_desc: result.data.content_desc,
							content_status: result.data.content_status,
							previewImg:
								result.data.content_image !== ""
									? FOTO_CONTENT_HOST + result.data.content_image
									: null,
							defaultImg:
								result.data.content_image !== "" ? null : "./noimage.gif"
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isLoading: false });
				})
				.catch(error => {
					console.log(error);
					Alert.error("Gagal terhubung ke server!");
					this.setState({ isLoading: false });
				});
		}
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">{this.props.mode} Berita</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Kategori
									</label>
									<div className="col-md-3">
										<FormDropdown
											name="cat_id"
											items={this.state.dataCat}
											onChange={this.handleChange}
											value={this.state.cat_id}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Judul Berita
									</label>
									<div className="col-md-9">
										<input
											name="content_name"
											type="text"
											className="form-control"
											placeholder="Judul Berita"
											onChange={this.handleChange}
											value={this.state.content_name}
										/>
									</div>
								</div>

								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Jenis Berita
									</label>
									<div className="col-md-3">
										<FormDropdown
											items={jenis_berita}
											onChange={this.handleChange}
											value={this.state.content_file_type}
											name="content_file_type"
										/>
									</div>
								</div>

								{this.state.content_file_type == "gambar" ?

									<div className="form-group row">
										<label className="col-md-2 form-control-label">Gambar</label>
										<div className="col-md-5">
											<label
												className="btn btn-info"
												style={{ cursor: "pointer" }}
											>
												Choose Image ...
												<input
													ref="file"
													name="content_image"
													type="file"
													onChange={this.onChange.bind(this)}
													hidden
												/>
											</label>{" "}
											&nbsp;
											{/*{this.state.previewImg && (
											<label
												onClick={this.clear.bind(this)}
												className="btn btn-danger"
												style={{ cursor: "pointer" }}
											>
												Clear
											</label>
										)}*/}
											{this.state.defaultImg && (
												<div>
													<img
														src={this.state.defaultImg}
														className="img-thumbnail"
														style={{ width: "320px", height: "180px" }}
														alt=""
													/>
												</div>
											)}
											{this.state.previewImg && (
												<div>
													<img
														src={this.state.previewImg}
														className="img-thumbnail"
														style={{ width: "320px", height: "180px" }}
														alt=""
													/>
												</div>
											)}
											{this.state.image &&
											!this.state.previewImg && (
												<div>
													<Cropper
														ref="crop"
														image={this.state.image}
														width={320}
														height={180}
														onImageLoaded={this.imageLoaded.bind(this)}
													/>
													<button
														onClick={this.crop.bind(this)}
														className="btn btn-md btn-success"
													>
														Crop
													</button>
													&nbsp;
													<button
														onClick={this.clear.bind(this)}
														className="btn btn-md btn-danger"
													>
														Clear
													</button>
												</div>
											)}
										</div>
									</div> :
									<div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Thumbnail Video</label>
											<div className="col-md-5">
												<label
													className="btn btn-info"
													style={{ cursor: "pointer" }}
												>
													Choose Image ...
													<input
														ref="file"
														name="content_image"
														type="file"
														onChange={this.onChange.bind(this)}
														hidden
													/>
												</label>{" "}
												&nbsp;
												{/*{this.state.previewImg && (
											<label
												onClick={this.clear.bind(this)}
												className="btn btn-danger"
												style={{ cursor: "pointer" }}
											>
												Clear
											</label>
										)}*/}
												{this.state.defaultImg && (
													<div>
														<img
															src={this.state.defaultImg}
															className="img-thumbnail"
															style={{ width: "320px", height: "180px" }}
															alt=""
														/>
													</div>
												)}
												{this.state.previewImg && (
													<div>
														<img
															src={this.state.previewImg}
															className="img-thumbnail"
															style={{ width: "320px", height: "180px" }}
															alt=""
														/>
													</div>
												)}
												{this.state.image &&
												!this.state.previewImg && (
													<div>
														<Cropper
															ref="crop"
															image={this.state.image}
															width={320}
															height={180}
															onImageLoaded={this.imageLoaded.bind(this)}
														/>
														<button
															onClick={this.crop.bind(this)}
															className="btn btn-md btn-success"
														>
															Crop
														</button>
														&nbsp;
														<button
															onClick={this.clear.bind(this)}
															className="btn btn-md btn-danger"
														>
															Clear
														</button>
													</div>
												)}
											</div>
										</div>

										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Video
											</label>
											<div className="col-md-9">
												<input
													name="content_file_url"
													type="text"
													className="form-control"
													placeholder="Link Video"
													onChange={this.handleChange}
													value={this.state.content_file_url}
												/>
											</div>
										</div>
									</div>
								}
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Deskripsi Singkat
									</label>
									<div className="col-md-9">
										<textarea
											name="content_shortdesc"
											type="number"
											className="form-control"
											placeholder="Deskripsi Singkat"
											onChange={this.handleChange}
											value={this.state.content_shortdesc}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Deskripsi Lengkap
									</label>
									<div className="col-md-9">
										<div>
											<Editor
												editorState={this.state.editorState}
												wrapperClassName="demo-wrapper"
												editorClassName="demo-editor"
												name="content_desc"
												onEditorStateChange={this.onEditorStateChange.bind(
													this
												)}
												toolbar={{
													options: [
														"inline",
														"blockType",
														"fontSize",
														"fontFamily",
														"list",
														"textAlign",
														"history",
														"link",
														"embedded",
														"emoji"
													]
												}}
											/>
										</div>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Status Aktif
									</label>
									<div className="col-md-3">
										<FormDropdown
											items={status_aktif}
											onChange={this.handleChange}
											value={this.state.content_status}
											name="content_status"
										/>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/News/Forms.js